module.exports = __webpack_public_path__ + "img/_01.e99108eb.png";